import { render, staticRenderFns } from "./DocPDFAdditional.vue?vue&type=template&id=68d6e549&scoped=true"
import script from "./DocPDFAdditional.vue?vue&type=script&lang=js"
export * from "./DocPDFAdditional.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d6e549",
  null
  
)

export default component.exports